<template>
  <div>
    <div :class="['caption', 'mx-4', 'my-2', $globalStyle.tableHeaderColor]">
      健檢日期
    </div>
    <new-report-date-picker label ref="datePicker"></new-report-date-picker>
    <div
      :class="[
        'caption',
        'mx-4',
        'mb-2',
        'mt-5',
        $globalStyle.tableHeaderColor
      ]"
    >
      請選擇醫師
    </div>
    <new-report-doctor-picker
      :clinic="clinic"
      v-model="doctor"
      style="margin-bottom:76px"
    ></new-report-doctor-picker>
    <div style="position: fixed;bottom:0;width:100%" class="pa-4">
      <v-btn
        depressed
        block
        :color="$classStyle.mainColor"
        large
        :dark="doctor !== undefined && !createBtnDisable"
        :disabled="doctor === undefined || createBtnDisable"
        :loading="createBtnDisable"
        @click="createReport"
        >確定</v-btn
      >
    </div>
  </div>
</template>
<script>
import NewReportDatePicker from "./NewReportDatePicker";
import NewReportDoctorPicker from "./NewReportDoctorPicker";

export default {
  props: ["clinic", "userName", "userPhone", "petId", "pet"],
  components: {
    NewReportDatePicker,
    NewReportDoctorPicker
  },
  data: () => ({
    doctor: undefined,
    createBtnDisable: false
  }),
  watch: {
    doctor() {}
  },
  methods: {
    create() {
      console.log("doctor:" + this.doctor);
      console.log("datePicker:" + this.$refs.datePicker.getDate());
    },
    async createReport() {
      this.createBtnDisable = true;
      let response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/reports/`,
        {
          clinic: this.clinic,
          date: this.$refs.datePicker.getDate(),
          doctor: this.doctor,
          name: this.userName,
          phone: this.userPhone,
          petId: this.petId,
          pet: {
            name: this.pet.name,
            breed: this.pet.breed,
            gender: this.pet.gender,
            age: this.$common.parsePetAge(this.pet.birth),
            type: this.pet.type
          }
        }
      );
      let reportId = response.data._id;
      this.$emit("onSelect", reportId);

      //send socket to notify web refresh
      response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/bot/socket`,
        {
          cmd: "updateReport",
          reportId: reportId,
          petId: this.petId
        }
      );

      this.createBtnDisable = false;
    }
  },
  mounted() {}
};
</script>
